import { ConfettiContext } from "@/contexts/ConfettiContext";
import { useContext } from "react";

export const useConfetti = () => {
    return useContext(ConfettiContext);
};
